import { useQuery } from '@tanstack/react-query'
import { useApi } from '../store/auth.store'

export interface CompanyUser {
  id: string
  email: string
  firstName: string
  lastName: string
  role: string
  isActive: boolean
  lastLogin: string | null
  createdAt: string
  area: { id: string; name: string } | null
}

export function useCompanyUsers() {
  const api = useApi()
  return useQuery<CompanyUser[]>({
    queryKey: ['company-users'],
    queryFn: () => api.get<CompanyUser[]>('/auth/users'),
  })
}